import React, { useState, useEffect } from 'react'
import { Card, Button, Form } from 'react-bootstrap';
import { useParams, useNavigate } from "react-router-dom";
import { axiosOpen } from '../../../../api/axios';
import { toast, Toaster } from 'react-hot-toast';

const SubscriptionEdit = () => {
    const navigate = useNavigate();
    const { planID } = useParams();
    const [name, setName] = useState("");
    const [status, setStatus] = useState('active');
    const [listings, setListings] = useState(0);
    const [loading, setLoading] = useState(false);
    const [description, setDescription] = useState('');


    useEffect(() => {
        (async () => {
            try {
                const { data } = await axiosOpen.get(`subscription/item/${planID}`);
                setName(data.name);
                setListings(data.listings)
                setStatus(data.subscription_status === 'true' ? 'active' : 'deactive');
                setDescription(data.description)
            } catch (error) {
                toast.error(error.response.data.message || "Oops! something went wrong.")
            }
        })();
    }, []);

    const handleSubmit = (event) => {
        event.preventDefault();
        if (!name || !status || !listings) {
            toast.error("Please enter valid input")
            return true;
        } else {
            setLoading(true);
            const updatePromise = new Promise((resolve, reject) => {
                (async () => {
                    try {
                        await axiosOpen.put(`subscription/update/${planID}`, {
                            name,
                            status: status === 'active' ? true : false,
                            listings,
                            description
                        });
                        setTimeout(() => {
                            setLoading(false);
                            navigate('/subscription/list', { replace: true });
                        }, 5000);
                        resolve(true)
                    } catch (error) {
                        reject(error.response.data.message || "Oops! something went wrong.")
                    }
                })();
            });

            toast.promise(updatePromise, {
                loading: 'Updating...',
                success: 'Subscription Plan Updated',
                error: (err) => `${err}`,
            });
        }
    };


    const handleCancel = () => navigate("/subscription/list", { replace: true });

    return (
        <div className='wrapper'>
            <Card>
                <Card.Header><h4>Update Subscription Plan</h4></Card.Header>
                <Card.Body>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group controlId="name" className="d-flex gap-3 align-items-center mb-3">
                            <Form.Label>Name</Form.Label>
                            <Form.Control type="text" value={name} onChange={(event) => setName(event.target.value)} required />
                        </Form.Group>
                        <Form.Group controlId="status" className="d-flex align-items-center gap-3 mb-3">
                            <Form.Label>Status</Form.Label>
                            <div className='d-flex'>
                                <Form.Check
                                    inline
                                    label="Active"
                                    name="status"
                                    type="radio"
                                    id="radio-status-active"
                                    value={"active"}
                                    checked={status === "active"}
                                    onChange={(e) => setStatus(e.target.value)}
                                />
                                <Form.Check
                                    inline
                                    label="Deactive"
                                    name="status"
                                    type="radio"
                                    id="radio-status-deactive"
                                    value={"deactive"}
                                    checked={status === "deactive"}
                                    onChange={(e) => setStatus(e.target.value)}
                                />
                            </div>
                        </Form.Group>
                        <Form.Group controlId="listings" className="d-flex align-items-center gap-2">
                            <Form.Label>Listings</Form.Label>
                            <Form.Control type="text" value={listings} onChange={(event) => setListings(event.target.value)} required />
                        </Form.Group>
                        <Form.Group controlId="description" className="d-flex align-items-center gap-2 my-3">
                            <Form.Label>Description</Form.Label>
                            <Form.Control type="text" value={description} onChange={(event) => setDescription(event.target.value)} required />
                        </Form.Group>
                        <div className='btns-group'>
                            <Button type="submit" variant="primary" className='btn-custom' disabled={loading}>{loading ? 'Updating...' : 'Update'}</Button>
                            <Button variant="secondary" className='btn-custom' onClick={handleCancel}>Cancel</Button>
                        </div>
                    </Form>
                </Card.Body>
            </Card>
            <Toaster
                position="top-right"
                reverseOrder={false}
            />
        </div>
    )
}

export default SubscriptionEdit